import { useEffect, useState } from 'react'
import { HttpSistema } from 'src/pages/sistema/api/httpSistema'
import { Comentario } from 'src/pages/sistema/types'
import { QueryStatus } from 'src/types'

export const useComentarios = (codSistema: number, idOperacion: number) => {
    const [comentarios, setComentarios] = useState<Comentario[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpSistema.getComentarios(codSistema, idOperacion)
            .then(value => {
                setComentarios(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [idOperacion])

    return { comentarios, status, refetch }
}
